import { RootState } from './store'

/**
 * select info about discount
 */
export const selectDiscountInfo = (state: RootState) => {
  const {
    displayDiscount,
    discountIsPercentage,
    totals: { maxSaleDiscount },
  } = state.currentSale
  return {
    displayDiscount,
    discountIsPercentage,
    maxSaleDiscount,
  }
}

/**
 * select sale discount
 */
export const selectSaleDiscount = (state: RootState) =>
  state.currentSale.discount

/**
 * select sale return for
 */
export const selectSaleReturnFor = (state: RootState) =>
  state.currentSale.returnFor
